import React, { useState, useRef } from "react";
import PageSideBar from "../PageSideBar";
import PageSideBarTop from "../PageSideBarTop";
import PageSideBarMenu from "../PageSideBarMenu";
import PageContent from "../PageContent";
import PageTopBar from "../PageTopBar";
import PageTopBarButton from "../PageTopBarButton";
import ScrollableContent from "../ScrollableContent";
import PageFooter from "../PageFooter";

import DropdownUser from "../DropdownUser";
import DropdownApp from "../DropdownApp";
import DropdownMessage from "../DropdownMessage";
import Gravatar from "../Gravatar";

import "./LayoutWithSideMenu.scss";

import sideMenuItems from "../../../SideMenuItems";
import appGroupItems from "../../../AppGroupItems";

import withSideMenuRolesFilter from "./withSideMenuRolesFilter";

import Countdown, { zeroPad } from "react-countdown";
import { Redirect } from "react-router-dom";
import { groupButtonIsVisible } from "../../../App";

import actualVersion from "../../../version";
import { useEffect } from "react";

const LayoutWithSideMenu = props => {
    const [isNotificationExpanded, setIsNotificationExpanded] = useState(false);
    const [isAppGroupExpanded, setIsAppGroupExpanded] = useState(false);
    const [isUserExpanded, setIsUserExpanded] = useState(false);
    const [menuExpanded, setMenuExpanded] = useState(true);
    const [sessionTime, setSessionTime] = useState(0);
    const [version] = useState(actualVersion);
    const [windowed] = useState(window.location.href.includes("#windowed"));
    const [dropdownButtonRef, setDropdownButtonRef] = useState([]);

    const toggleNotification = () => {
        setIsNotificationExpanded(!isNotificationExpanded);
        setIsAppGroupExpanded(false);
        setIsUserExpanded(false);
    };

    const toggleAppGroup = () => {
        setIsNotificationExpanded(false);
        setIsAppGroupExpanded(!isAppGroupExpanded);
        setIsUserExpanded(false);
    };

    const toggleUser = () => {
        setIsNotificationExpanded(false);
        setIsAppGroupExpanded(false);
        setIsUserExpanded(!isUserExpanded);
    };

    const checkOtherButtonClickedAndHideDropdowns = event => {
        let isInAnyButton = false;

        dropdownButtonRef.forEach(item => {
            if (!!item.current && item.current.contains(event.target)) {
                isInAnyButton = true;
            }
        });

        if (!isInAnyButton) {
            hideDropdowns();
        }
        event.stopPropagation();
    };

    const hideDropdowns = () => {
        setIsNotificationExpanded(false);
        setIsAppGroupExpanded(false);
        setIsUserExpanded(false);
    };

    const setDropdownButtonRefIfNotInclude = node => {
        if (!dropdownButtonRef.includes(node)) {
            dropdownButtonRef.push(node);
        }
    };

    const handleMenuClick = () => {
        setMenuExpanded(!menuExpanded);
    };

    useEffect(() => {
        getSessionTimeFromToken();
        // getBreadcrumbsFromLocation();
        if (!windowed) {
            document.addEventListener(
                "mousedown",
                checkOtherButtonClickedAndHideDropdowns
            );
        }
        return () => {
            document.removeEventListener(
                "mousedown",
                checkOtherButtonClickedAndHideDropdowns
            );
        };
    }, [windowed]);

    const getWindowDimensions = () => {
        const { innerWidth: width, innerHeight: height } = window;
        return {
            width,
            height,
        };
    };

    useEffect(() => {}, []);

    const closeMenu = () => {
        var windowSize = getWindowDimensions();
        if (windowSize.width < 700 && windowSize.height < 700) {
            setMenuExpanded(false);
        }
    };

    const getSessionTimeFromToken = () => {
        let sessionTime =
            sessionStorage.getItem("sessionTime") ??
            localStorage.getItem("sessionTime");
        setSessionTime(!!sessionTime ? sessionTime * 1000 : 0);
    };

    const completeCondition = ({
        days,
        hours,
        minutes,
        seconds,
        completed,
    }) => {
        if (completed) {
            return <Redirect to="/signout" />;
        } else {
            return (
                <span>
                    {zeroPad(hours + 24 * days)}:{zeroPad(minutes)}:
                    {zeroPad(seconds)}
                </span>
            );
        }
    };

    const messages = [
        {
            title: "Message 1",
            image: "",
            creationTime: "2022-07-14T11:45:55",
            text: "Content",
        },
        {
            title: "Message 2",
            image: "",
            creationTime: "2022-07-14T11:45:55",
            text: "Content",
        },
        {
            title: "Message 3",
            image: "",
            creationTime: "2022-07-13T11:45:55",
            text: "Content",
        },
        {
            title: "Message 4",
            image: "",
            creationTime: "2022-07-13T11:45:55",
            text: "Content",
        },
        {
            title: "Message 5",
            image: "",
            creationTime: "2022-07-11T11:45:55",
            text: "Content",
        },
    ];

    let notificationDropdown = (
        <DropdownMessage
            isExpanded={isNotificationExpanded}
            messages={messages}
        />
    );

    let appGroupDropdown = (
        <DropdownApp
            isExpanded={isAppGroupExpanded}
            items={appGroupItems}
            // buttonClicked={hideDropdowns}
        />
    );

    let userGroupDropdown = (
        <DropdownUser
            onRef={o => dropdownButtonRef.push(o)}
            isExpanded={isUserExpanded}
            avatar={<Gravatar isVisible={true} email={props.email} />}
            username={props.username}
            roles={props.roles}
            signOutUrl="#/signout"
            buttonClicked={hideDropdowns}
        />
    );

    return (
        <div className="layout-with-sidemenu">
            {!windowed ? (
                <PageSideBar expanded={menuExpanded}>
                    <PageTopBarButton
                        id="menu-close-button"
                        icon={<i className="dx-icon dx-icon-remove"></i>}
                        onClick={handleMenuClick}
                        isOnDark={true}
                        isVisible={menuExpanded}
                    />
                    <PageSideBarTop logo={props.logo} appName={props.appName} />
                    <PageSideBarMenu menuItems={props.sideMenuItems} />
                </PageSideBar>
            ) : (
                ""
            )}

            <PageContent>
                {!windowed ? (
                    <PageTopBar>
                        <PageTopBarButton
                            id="toogle-user-button"
                            icon={
                                <Gravatar
                                    isVisible={true}
                                    email={props.email}
                                />
                            }
                            onRef={setDropdownButtonRefIfNotInclude}
                            dropdown={userGroupDropdown}
                            onClick={toggleUser}
                            isVisible={true}
                        />
                        <PageTopBarButton
                            id="toogle-notification-button"
                            icon={<i className="far fa-bell"></i>}
                            onRef={setDropdownButtonRefIfNotInclude}
                            dropdown={notificationDropdown}
                            onClick={toggleNotification}
                            isVisible={false}
                        />
                        <PageTopBarButton
                            id="toogle-app-group-button"
                            icon={<i className="fas fa-th"></i>}
                            onRef={setDropdownButtonRefIfNotInclude}
                            dropdown={appGroupDropdown}
                            onClick={toggleAppGroup}
                            isVisible={groupButtonIsVisible}
                        />
                        <PageTopBarButton
                            id="menu-expand-button"
                            align="left"
                            icon={<i className="fas fa-bars"></i>}
                            onClick={handleMenuClick}
                            isVisible={!menuExpanded}
                        />
                        <span className="countdownTimer" id="user-name-topbar">
                            {props.username}
                        </span>
                        <div className="countdownTimer">
                            <Countdown
                                date={sessionTime}
                                key={sessionTime}
                                renderer={completeCondition}
                            />
                        </div>
                        {props.indicator}
                        <a id="innsoft-button" href="http://www.innsoft.pl">
                            <img
                                className="logo-top"
                                src="images/logo.png"
                                alt=""
                            ></img>
                        </a>
                    </PageTopBar>
                ) : (
                    ""
                )}
                <ScrollableContent onClick={closeMenu}>
                    <div className="layout-with-sidemenu-content">
                        <div className="layout-with-sidemenu-inner-content">
                            {props.children}
                        </div>
                    </div>
                </ScrollableContent>
                {!windowed ? (
                    <PageFooter version={version} expanded={menuExpanded} />
                ) : (
                    ""
                )}
            </PageContent>
        </div>
    );
};

export default withSideMenuRolesFilter(LayoutWithSideMenu, sideMenuItems);
